import { Platform } from '@/types/platform'

import * as bazaarConfig from './bazaar'
import * as cosmoConfig from './cosmo'
import * as esquireConfig from './esquire'
import * as goodhouseConfig from './goodhouse'
import * as graziaConfig from './grazia'
import * as mhealthConfig from './mhealth'
import * as popmechConfig from './popmech'
import * as robbConfig from './robb'
import * as arcanConfig from './arcan'
import * as vslovaConfig from './vslova'

interface Config {
  colorsBackground: string[]
  colorsFonts: string[]
}

export default function getColorsCalendarConfig(platform: Platform): Config {
  switch (platform) {
    case Platform.bazaar:
      return bazaarConfig

    case Platform.esquire:
      return esquireConfig

    case Platform.goodhouse:
      return goodhouseConfig

    case Platform.grazia:
      return graziaConfig

    case Platform.mhealth:
      return mhealthConfig

    case Platform.popmech:
      return popmechConfig

    case Platform.robb:
      return robbConfig

    case Platform.arcan:
      return arcanConfig

    case Platform.vslova:
      return vslovaConfig

    default:
      return cosmoConfig
  }
}
